import { getPlanStyle } from '../../utils/planStyles';
import React from 'react';
import { Crown } from 'lucide-react';

const labels = {
  business_trial: 'Business Trial',
  commercial_agreement: 'Commercial agreement',
  plan: 'Plan',
};

export default function LimitSourceBadge({ source }) {
  const trial = source === 'business_trial';
  return <span className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${
    trial ? getPlanStyle('business_trial').badge : 'bg-gray-100 text-gray-800'
  }`}>
    {trial && <Crown className="w-3 h-3 mr-1" aria-hidden="true" />}
    {labels[source] || 'Plan'}
  </span>;
}
